<template>
    <div>
        <vapp-header btnBack></vapp-header>
        <pdf
                v-for="i in numPages"
                :key="i"
                :src="src"
                :page="i"
        ></pdf>
    </div>
</template>


<script>
    import pdf from 'vue-pdf'
    import axios from 'axios'
    import { mapState } from 'vuex'

    export default {
        name: "ViewInvoicePDF",
        components: {
            pdf
        },
        computed: {
            ...mapState('invoice',['editInvoiceObj']),
            ...mapState('auth', ['sessions'])
        },
        data: () => ({
            src: null,
            numPages: undefined,
        }),
        mounted() {
            console.log("Mounted : View  Invoice PDF");
            let invoiceId = this.editInvoiceObj.id;
            let encryptedToken = this.sessions.encrypted_token;
            let baseUrl = axios.defaults.baseURL;
            this.$root.$emit('show-loading', true);
            this.axios
                .get('/sales/invoices/' + invoiceId +'/pdf?k=a1cab95df79930fa63947a2bc6f746dd&t=' + encryptedToken)
                .then(() => {
                    this.src = pdf.createLoadingTask( baseUrl + '/sales/invoices/' + invoiceId +'/pdf?k=a1cab95df79930fa63947a2bc6f746dd&t=' + encryptedToken);
                    this.src.then(pdf => {
                        this.numPages = pdf.numPages;
                        this.$root.$emit('show-loading', false);
                    });
                })
                .catch(error => {
                    this.$root.$emit('show-loading', false);
                    this.$generalAPIErrorHandling(error, this.$router);
                })
        }
    }
</script>

<style scoped>

</style>
